<template>
    <div class="col-md-6 offset-md-3" style="padding:15px">
        <div id=loginDiv>        
            <router-link to="/">
                <img id="logoLoginPage" src="/images/openplan.png" alt="logo Prolendar">
            </router-link>

        <h2>Congratulations! </h2>
        <p>You have succesfully reset your password. You can access the platform right now by pressing the button below.</p>

        <form @submit.prevent="onSubmit">
            <div class="form-group" style="margin-top:30px; text-align:center" >
                <router-link v-if="!user" :to="{ name: 'login'}">
                    <button class="btn btn-edit" :disabled="loading">Open Platform</button>
                </router-link>
                <router-link v-else-if="isOwner" :to="{ name: 'propertiesowner'}">
                    <button class="btn btn-edit" :disabled="loading">Open Platform</button>
                </router-link>
                <router-link v-else  :to="{ name: 'buildings'}">
                    <button class="btn btn-edit" :disabled="loading">Open Platform</button>
                </router-link>            
                <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div>
        </form>

    </div>

    <!-- Icons for mobile app: -->
    <!-- <table border=1 id="tableForGooglePlay">
        <tr>
            <td style="text-align: center;">
                <a href="https://apps.apple.com/gb/app/prolendar/id1315846400?ign-mpt=uo%3D2" target="_blank">
                        <img style="height: 30px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadFromAppStore.png" alt="download from Apple Store icon">
                </a>
            </td>
            <td style="width:13px">   </td>
            <td style="text-align: center;">
                <a href="https://play.google.com/store/apps/details?id=com.prolendar.prolendarnew&hl=en" target="_blank">
                        <img style="height: 29px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadFromGooglePlay.png" alt="download from Google Play icon">
                </a>
            </td>
        </tr>
    </table> -->

    </div>
</template>

<style scoped>
p{
    font-size:16px;
    text-align: center
}
#tableForGooglePlay{
    margin: auto;
    width: 40%;
    margin-top: 13px;
}

#loginDiv{
    margin: auto;
    width: 530px;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white
}
#logoLoginPage{
    height: auto;
    width: 70%;
    display: block;
    margin-left: auto;
    margin-right: auto;    
}

h2{
    margin-bottom: 13px;
    margin-top:-35px; 
    text-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;
    
}
</style>



<script>
import { required } from '@vuelidate/validators';
import { router } from '@/_helpers';
import { authenticationService } from '@/_services';

export default {
    data () {
        return {
            name: '',
            currentUser: null,
            loading: false,
            
        }
    },
    computed: {
        // loggingIn () {
        //     return this.$store.state.authentication.status.loggingIn;
        // },
        user() {
            return authenticationService.currentUserValue;
           /* alert( this.$store.state.authentication.user)
            return this.$store.state.authentication.user;*/
        },
        isAdmin() {
                return this.currentUser && this.currentUser.role === Role.Admin;
        },
        isOwner(){
            return this.currentUser && this.currentUser.role === Role.Owner;
        },
        users () {
            return this.$store.state.users.all;
        }
    },
    
    methods: {
        onSubmit () {
            this.$router.push('/login')
        }
    },

    // Is this neccessary?
    created () {
        authenticationService.currentUser.subscribe(x => this.currentUser = x);
      //  this.$store.dispatch('users/getAll');
    }

};
</script>